import { createStateHook } from 'react-sweet-state';
import { store } from '../../main';
import { selectReadyPublicDataForOnInit } from './utils';
export var useReadyPublicDataForOnInit = createStateHook(store, {
  selector: selectReadyPublicDataForOnInit
});